import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { API_ENDPOINTS } from '../constants/api-endpoints.constant';

@Injectable({
  providedIn: 'root'
})
export class WipodService {

  constructor(private apiService: ApiService) { }

  createCollaborationRequest(param) {
    return this.apiService.post(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.COLLABORATIONS, param);
  }

  fetchPendingCollaborationRequest() {
    return this.apiService.get(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.COLLABORATIONS + API_ENDPOINTS.API.LIST_PENDING_COLLABORATION);
  }

  fetchCollaborationContents(param) {
    return this.apiService.get(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.COLLABORATIONS + API_ENDPOINTS.API.CONTENT_COLLABORATOR_LIST, param);
  }

  acceptOrRejectRequest(data, collaboration_id) {
    return this.apiService.put(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.COLLABORATIONS + '/' + collaboration_id + API_ENDPOINTS.API.APPROVED_DECLINED_COLLABORATION, data);
  }
  checkContentStatus(param) {
    return this.apiService.get(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.CONTENT_TEXTS + API_ENDPOINTS.API.GET_STATUS, param);
  }

  lockContent(params) {
    return this.apiService.put(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.CONTENT_TEXTS + API_ENDPOINTS.API.COLLABORATION_LOCKED, params);
  }

  unlockContent(params) {
    return this.apiService.put(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.CONTENT_TEXTS + API_ENDPOINTS.API.COLLABORATION_UNLOCKED, params);
  }

  addCollabContent(params) {
    return this.apiService.post(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.CONTENT_TEXTS, params);
  }

  updateCollaboratorContent(params) {
    return this.apiService.put(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.CONTENT_TEXTS + API_ENDPOINTS.API.UPDATE_COLLABORATOR_CONTENT_TEXT, params);
  }

  deleteCollabRequest(params) {
    return this.apiService.delete(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.COLLABORATIONS + '/' + params);
  }

  deleteContentRights(params) {
    return this.apiService.post(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.COLLABORATIONS + API_ENDPOINTS.API.COLLABORATOR_DELETE_COLLABRATION, params);
  }

  deleteWipodContent(contentID) {
    return this.apiService.get(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.CONTENTS + '/' + contentID + API_ENDPOINTS.API.REMOVE_WIPOD);
  }

  updateCollaboration(collaborationID, params) {
    return this.apiService.put(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.COLLABORATIONS + '/' + collaborationID, params);
  }

  checkReviewCollaboration(collaborationID, contentID) {
    return this.apiService.get(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.COLLABORATIONS + '/' + collaborationID + API_ENDPOINTS.API.COLLABORATION_REVIEW + '?content_id=' + contentID);
  }
}
